// SESSION_FEEDBACK number questions are scored out of 5 by default (bounded to 1–5),
// but the legacy forms listed below are scored out of 10 (bounded to 1–10).
// Matched against the form's `metadata.legacyId` (pre-migration form id).
export const SESSION_FEEDBACK_NUMBER_MIN = 1;
export const SESSION_FEEDBACK_DEFAULT_MAX = 5;
const SESSION_FEEDBACK_MAX_10_LEGACY_IDS = new Set([
  "form-recYqaZRuo5iEPYVR",
  "form-reclFiAfuPrFV7KhT",
  "form-rec1N1A0FegZu2Rhy",
  "form-recVWtJk1hYIyqrkJ",
  "form-recqt3rLTnPSnIHyr",
  "form-rec1I30ElKPiHgKKx",
  "form-reccTOjxYbys634bV",
  "form-recVhcRDYBvPCoghk",
  "form-recoQbFlZk4VCT5GH",
  "form-rec4BHzZN3xCRIHxZ",
  "form-recP96wLJ202kA35W",
  "form-recjB8NRFjfL17eXu",
  "form-recA60anhFk1nJ4zR"
]);

export interface NumberRange {
  min: number;
  max: number;
}

// Shared by both the personalized form and the tabular (group/generic) grid so a SESSION_FEEDBACK
// number question is always bounded and labelled the same way regardless of which view renders it.
export const getSessionFeedbackNumberRange = (legacyId?: string | null): NumberRange => ({
  min: SESSION_FEEDBACK_NUMBER_MIN,
  max: legacyId && SESSION_FEEDBACK_MAX_10_LEGACY_IDS.has(legacyId) ? 10 : SESSION_FEEDBACK_DEFAULT_MAX
});
